export default {
  SET_REPORTS(state, reports) {
    state.reports = reports
  },
  ADD_REPORT(state, payload) {
    state.reports.unshift(payload)
  },
  SET_REPORT_TYPES(state, reportTypes) {
    state.reportTypes = reportTypes
  },
}
